"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var VariableWidget_1 = require("Project/QwilrEditor/Widgets/VariableWidget/VariableWidget");
var VariableActions_1 = require("Project/QwilrEditor/Behaviours/VariableActions");
var react_1 = __importDefault(require("react"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var EditorTypes_1 = require("./EditorTypes");
var LinkWidget_1 = __importDefault(require("./Widgets/LinkWidget/LinkWidget"));
var TokenWidget_1 = require("Project/QwilrEditor/Widgets/TokenWidget");
var SlateUtils_1 = require("./Behaviours/SlateUtils");
var Types_1 = require("Tokens/Types");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var RegistryElement_1 = require("./RegistryElement");
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var renderElement = function (properties, value, editor, widgetManager, onChange, usingFeature, blockStore, brandStore, stylePermissionStore, editorTelemetry, uploadStore, embedUrlGenerator, activeTokenToolbarStore, blockIndex, config, disableWidgetAdder, widgetToolbarHost) {
    var element = properties.element;
    var isRegistryComponent = !!(0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type, true);
    if (isRegistryComponent) {
        var tokensEnableState_1 = enableTokens(widgetManager, blockStore);
        return (react_1.default.createElement(DIProvider_1.default, { container: function () {
                var container = new inversify_1.Container({ skipBaseClassChecks: true });
                container.bind("tokensEnableState").toConstantValue(tokensEnableState_1);
                return container;
            } },
            react_1.default.createElement(RegistryElement_1.RegistryElement, { properties: properties })));
    }
    switch (element.type) {
        case EditorTypes_1.InlineType.Link:
            return renderLinkWidget(properties, widgetManager, usingFeature, blockStore, brandStore, stylePermissionStore, config, editor, widgetToolbarHost);
        case EditorTypes_1.InlineType.LineBreak:
            return renderLineBreak(properties);
        case EditorTypes_1.InlineType.Variable:
            return renderVariableWidget(properties, widgetManager, activeTokenToolbarStore, editorTelemetry);
        case EditorTypes_1.InlineType.TokenWidget:
            return renderTokenWidget(properties, widgetManager, editor);
        default:
            throw new Error("Unrecognised node type provided: ".concat(element.type));
    }
    return null;
};
exports.default = renderElement;
var renderLinkWidget = function (_a, widgetManager, usingFeature, blockStore, brandStore, stylePermissionStore, config, editor, widgetToolbarHost) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    return (react_1.default.createElement(LinkWidget_1.default, { href: element.data.href, focus: element.data.focus, widgetManager: widgetManager, element: element, usingFeature: usingFeature, blockStore: blockStore, brandStore: brandStore, stylePermissionStore: stylePermissionStore, config: config, isInsideTableCell: isInsideTableCell(editor, slate_react_1.ReactEditor.findPath(editor, element)), isInsideAccordion: (0, SlateUtils_1.hasBlockTypeAsAncestor)({
            selectionPath: slate_react_1.ReactEditor.findPath(editor, element),
            blockType: "accordion",
            editor: editor,
        }), attributes: attributes, toolbarHost: widgetToolbarHost }, children));
};
var renderVariableWidget = function (_a, widgetManager, activeTokenToolbarStore, editorTelemetry) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    return (react_1.default.createElement(VariableWidget_1.VariableWidget, { activeTokenToolbarStore: activeTokenToolbarStore, variableName: element.data.variableName, variableLabel: element.data.variableLabel, isItalic: element.data[VariableActions_1.VariableStyleKey.IsItalic], isStrikethrough: element.data[VariableActions_1.VariableStyleKey.IsStrikethrough], isBold: element.data[VariableActions_1.VariableStyleKey.IsBold], widgetManager: widgetManager, editorTelemetry: editorTelemetry, attributes: attributes, element: element }, children));
};
var isInsideTableCell = function (editor, path) {
    var ancestors = slate_1.Path.ancestors(path);
    return ancestors.some(function (ancestor) {
        var ancestorNode = slate_1.Editor.node(editor, ancestor)[0];
        return slate_1.Element.isElement(ancestorNode) && ancestorNode.type === "tableCell";
    });
};
var renderTokenWidget = function (_a, widgetManager, editor) {
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    return (react_1.default.createElement(TokenWidget_1.TokenWidget, { attributes: attributes, widgetManager: widgetManager, element: element, editor: editor }, children));
};
var renderLineBreak = function (renderElementProps) {
    return (react_1.default.createElement("span", __assign({}, renderElementProps.attributes),
        renderElementProps.children,
        react_1.default.createElement("br", null)));
};
var enableTokens = function (widgetManager, blockStore) {
    if (widgetManager.isInTemplate()) {
        return Types_1.TokensEnableState.EnabledWithAllInteractions;
    }
    if (blockStore.isSavedBlock) {
        return Types_1.TokensEnableState.EnabledWithoutDragAndDrop;
    }
    return Types_1.TokensEnableState.Disabled;
};
